import { render } from "./ButtonApple.vue?vue&type=template&id=b082aebe"
import script from "./ButtonApple.vue?vue&type=script&lang=js"
export * from "./ButtonApple.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__